import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertController, IonModal, LoadingController } from '@ionic/angular';

import * as moment from 'moment';
import { Profile, UserService } from 'octali-lib-firebase-utils';
import { DisplayerService } from 'octali-lib-utils';
import { Subscription } from 'rxjs';

import { IonDatetime } from '@ionic/angular';
import { format, parseISO } from 'date-fns';

@Component({
  selector: 'app-account',
  templateUrl: './account.page.html',
  styleUrls: ['./account.page.scss'],
})
export class AccountPage implements OnInit {

  
  @ViewChild('datetime', { read: IonDatetime, static: false }) datetime: IonDatetime;
  @ViewChild('dateModal', { read: IonModal, static: false }) dateModal: IonModal;

  public profileForm: FormGroup;
  private subscription: Subscription;
  public maxDate: string;
  public dateValue: string;
  private profile: Profile;

  constructor(
    private formBuilder: FormBuilder,
    private profileService:UserService,
    private loadingCtrl:LoadingController,
    private router:Router,
    private displayer:DisplayerService,
    private alertCtrl: AlertController
  ) { 

    this.maxDate = moment().subtract("18","y").format("YYYY-MM-DD");

    this.initForm();
    this.subscription = this.profileService.getUser().subscribe(p => {
      if(p){
        this.profile = p;
        this.profileForm.controls.firstname.setValue(p.firstname);
        this.profileForm.controls.lastname.setValue(p.lastname);
        this.profileForm.controls.email.setValue(p.mail);
        this.profileForm.controls.phone.setValue(p.phone);
        this.profileForm.controls.mobile.setValue(p.mobile);
        let d = moment(p.dateOfBirth).format("DD-MM-YYYY");
        this.profileForm.controls.dateOfBirth.setValue( d );
        //this.dateValue = this.formatDate( p.dateOfBirth );
      }
    }); 
  }

  // test au moins 1 téléphone
  onePhone(phone: string, mobile: string) {
    return (group: FormGroup): {[key: string]: any} => {
       let phoneControl = group.controls[phone];
       let mobileControl = group.controls[mobile];
       if((phoneControl.value == null ||phoneControl.value == "") && (mobileControl.value == null || mobileControl.value == ""))
       return {
        'onePhone': true
        };
    }
  }

  ngOnInit() {
    
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  initForm() {
    this.profileForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['',Validators.required],
      //password: ['',Validators.compose([Validators.minLength(6), Validators.required])],
      dateOfBirth: ['', Validators.required],
      phone: [null,Validators.compose([Validators.minLength(10), Validators.maxLength(10)])],
      mobile: [null,Validators.compose([Validators.minLength(10), Validators.maxLength(10)])],
    }, { validator: this.onePhone('phone','mobile')}
    );   
  }

  async onSubmitForm(){
    console.log("click");
    if (!this.profileForm.valid) {
      console.log(this.profileForm.value);
    } else {
      const loading = await this.loadingCtrl.create();
      loading.present();
      this.profile.firstname = this.profileForm.value.firstname;
      this.profile.lastname = this.profileForm.value.lastname;
      this.profile.mail = this.profileForm.value.email;
      this.profile.phone = this.profileForm.value.phone;
      this.profile.mobile = this.profileForm.value.mobile;
      this.profile.dateOfBirth = this.dateValue;//moment(this.profileForm.value.dateOfBirth).format("YYYY-MM-DDTHH:mm:ssTZD");
      this.profile.tokens = new Map<string,string>();
      this.profileService.updateUser( this.profile ).then(() => {
        loading.dismiss().then(() => {
          this.displayer.presentAlert("Infos personnelles","","Vos informations ont bien été sauvegardées");
        });
      },error => {
        loading.dismiss().then(async () => {
          const alert = await this.alertCtrl.create({
            message: error.message,
            buttons: [{ text: 'Ok', role: 'cancel' }],
          });
          alert.present();
        });
      });
      /*this.profileService.update(
        this.profileForm.value.firstname,
        this.profileForm.value.lastname,
        this.profileForm.value.email,
        this.profileForm.value.phone,
        this.profileForm.value.mobile,
        this.profileForm.value.dateOfBirth
      ).then(() => {
        loading.dismiss().then(() => {
          this.displayer.presentAlert("Infos personnelles","","Vos informations ont bien été sauvegardées");
        });
      },error => {
        loading.dismiss().then(async () => {
          const alert = await this.alertCtrl.create({
            message: error.message,
            buttons: [{ text: 'Ok', role: 'cancel' }],
          });
          alert.present();
        });
      });*/
    }
  }
  confirm() {
    this.datetime.confirm();
    this.dateModal.dismiss();
  }

  changeDate( date ) {
    console.log(date);
    this.dateValue = date;
    this.profileForm.controls.dateOfBirth.setValue(moment(date).format("DD-MM-yyyy"));
  }

  cancel() {
    this.datetime.cancel();
    this.dateModal.dismiss();
  }
  
  reset() {
    this.datetime.reset();
  }

  formatDate(value: string) {
    console.log(value);
    if(value)
      return format(parseISO(value), 'dd MM yyyy');
    else
      return "";
      //return format(moment.now(), 'dd MM yyyy');
  }

}
